import * as ActionTypes from '../constants/ActionTypes';

const initialStateNewsletter = {
    email: null,
    status: false
}

/*
*
* Newsletter
*
* <action.type> return new state
* of the store
*
* @param email, status
* @return store.newsletterState
*
*/

export default (state = initialStateNewsletter, action) => {
    switch (action.type){
        
        case ActionTypes.SAVE_EMAIL:
            state = Object.assign({}, state, {
                email: action.email,
                status: action.data
            });
        return state;
        
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/NewsletterReducer.js